import utility from "src/utils/utility";
import React, {useState} from 'react'
import { useNavigate } from "react-router-dom";
import {
  AppText,
  Button,
  FlexColumn,
  FlexRow,
  ScreenContainer,
  ScreenTitle,
  OutlineButton,
} from "src/style";
import Logo from "src/assets/img/main-logo.jpg";
import "./index.scss";

const LandingPage: React.FC<any> = ({ data }) => {
  const navigate = useNavigate();
  const [checked, setChecked] = useState(false)


  return (
    <ScreenContainer className="landingPage">
      <div className="signIn__cover"></div>

      <FlexRow
        className="landingPage__nav"
        justifyContent="space-around"
        alignItems="center"
      >
        <div className="img__container">
          <img src={Logo} alt="" className="img" />
        </div>
        <ul className={`landingPage__nav--items ${checked && "active"}`}>
          <li className="landingPage__nav--item">Home</li>
          <li className="landingPage__nav--item">Gallery</li>
          <li className="landingPage__nav--item">About us</li>
        </ul>
        <FlexRow width="15">
          <Button
            radius=".5"
            bgColor="#702126"
            color="#ffffff"
            className="landingPage__btn"
            fontWeight="350"
            onClick={() => navigate('/signin')}
            hoverBgColor='transparent'
          >
            Get Started
          </Button>
          <div className="nav__icon">
            <input
              type="checkbox"
              className={`navigation__checkbox`}
              id="navi-toggle"
              checked={checked}
              onChange={(e) => setChecked(e.target.checked)}
            />
            <label htmlFor="navi-toggle" className={`navigation__button`}>
              <span className={`navigation__icon`}>&nbsp;</span>
            </label>
          </div>
        </FlexRow>
      </FlexRow>

      <FlexColumn className="landingPage__hero--section">
        <ScreenTitle
          color="#fff"
          textSize="6.5"
          bottomMargin="3"
          className="heading--primary"
          align="center"
        >
          Virtuous Sprout Academy
        </ScreenTitle>
        <AppText
          fontWeight="400"
          bottomMargin="1"
          align="center"
          rightPadding="2"
          leftPadding="2"
        >
          An Haven Where You Get Your Child A Solid/Sound Western Islamic And
          Islamic Education.
        </AppText>
        <AppText
          fontWeight="400"
          bottomMargin="4"
          align="center"
          rightPadding="2"
          leftPadding="2"
        >
          We Offer Western Education, Tahfeedhul Qur'an, Virtue And Etiquette,
          Extra-Curriculum, I.T And Computer Training
        </AppText>
        <OutlineButton
          color="#fff"
          radius=".5"
          hoverBgColor="#702126"
          hoverColor="#fff"
          fontWeight="400"
          className="hero--btn"
          onClick={() => navigate("/signin")}
        >
          Get Started <span>&#62;</span>
        </OutlineButton>
      </FlexColumn>
    </ScreenContainer>
  );
};

export default utility.routeData("/", "Landing Page", <LandingPage />);
